import React, {useCallback} from 'react';
import I18n from 'app/i18n';
import SmartSelectItem from 'app/components/reusable/SmartSelectItem';
import CollectionInterface from 'app/interfaces/CollectionInterface';
import {
    PROMO_NEW_FILTER_TABS,
    PROMO_NEW_SORT_OPTIONS,
    PromoNewFilterType,
    PromoNewSortType
} from 'app/utils/promoNewFilterUtils';

interface PromoNewFiltersProps {
    filterType: PromoNewFilterType;
    sortType: PromoNewSortType;
    onFilterChange: (filterType: PromoNewFilterType) => void;
    onSortChange: (sortType: PromoNewSortType) => void;
}

const FILTER_TAB_LABEL_KEYS: Record<PromoNewFilterType, string> = {
    all: 'promo_new_tab_all',
    bets: 'promo_new_header_bets',
    casino: 'promo_new_header_casino',
    permanent: 'promo_new_header_permanent'
};

const SORT_OPTION_LABEL_KEYS: Record<PromoNewSortType, string> = {
    ending_soon: 'promo_new_sort_ending_soon',
    popular: 'sortings.popular',
    recently_added: 'promo_new_sort_recently_added'
};

const SORT_OPTIONS_COLLECTION: CollectionInterface[] = PROMO_NEW_SORT_OPTIONS.map(option => ({
    text: SORT_OPTION_LABEL_KEYS[option],
    value: option
}));

const PromoNewFilters = ({
    filterType,
    sortType,
    onFilterChange,
    onSortChange
}: PromoNewFiltersProps): React.ReactElement => {
    const handleSortChange = useCallback((value: string | number) => {
        onSortChange(value as PromoNewSortType);
    }, [onSortChange]);

    const createFilterClickHandler = useCallback((tab: PromoNewFilterType): (() => void) => (): void => {
        onFilterChange(tab);
    }, [onFilterChange]);

    return (
        <div className="promo-new-filters">
            <div className="promo-new-filters__tabs">
                {PROMO_NEW_FILTER_TABS.map(tab => {
                    const isActive = filterType === tab;

                    return (
                        <button
                            key={tab}
                            type="button"
                            className={`promo-new-filters__tab${isActive ? ' promo-new-filters__tab--active' : ''}`}
                            onClick={createFilterClickHandler(tab)}
                        >
                            {I18n.t(FILTER_TAB_LABEL_KEYS[tab])}
                        </button>
                    );
                })}
            </div>
            <div className="promo-new-filters__sort">
                <span className="promo-new-filters__sort-label">{I18n.t('sort_by')}</span>
                <div className="promo-new-filters__sort-select">
                    <SmartSelectItem
                        collection={SORT_OPTIONS_COLLECTION}
                        onChange={handleSortChange}
                        value={sortType}
                        htmlId="promo_new_sort"
                        nameAttr="promo-new-sort"
                    />
                </div>
            </div>
        </div>
    );
};

export default PromoNewFilters;
